import React from 'react';
import Submenu from './Submenu';
import { favoritesMangerPath } from '../../../utils/favorites';
import config from '../../../config';

class AccountMenu extends Submenu {

  constructor(props) {
    super(props);
    this.links = config.links;
    this.user = props.user;
  }

  render() {
    const navClasses = super.getMenuClasses('accountMenu');
    return (
      <ul id="accountMenu" className={navClasses}>
        <li className="header">Account</li>
        <li className="default"><a href={this.links.account.information}>Account Information</a></li>
        <li className="default"><a href={favoritesMangerPath}>Edit Favorites</a></li>
        <li className="default"><a href={this.links.account.payment}>Payment and Password</a></li>
        <li className="default"><a href={super.exitLink(this.links.funnel.logout)}>Sign Out</a></li>
      </ul>
    );
  }
}

export default AccountMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/AccountMenu.js